import React from 'react';
import styled, { css } from 'styled-components';
import { useOnClickOutside } from 'usehooks-ts';

const DrawerWrapperFull = styled.div`
  height: 100%;
  /* width: 100%; */
  position: relative;
  /* left: -100%; */
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0);
  transition: left 250ms ease-in-out;

  z-index: ${props => props.theme.zIndex.drawer};

  @media only screen and (max-width: ${props => props.theme.mq.large}) {
    position: absolute;
    left: -100%;

    ${props =>
      props.show &&
      css`
        left: 0;
      `};
  }
`;

const DrawerWrapper = styled.div`
  width: 280px;
  min-height: 100%;
  height: auto;
  position: relative;
  left: 0;
  top: 0;
  background: ${props => props.theme.colors.white};
  box-shadow: 0 5.5px 5px 0 rgba(0, 0, 0, 0.24),
    0 9px 18px 0 rgba(0, 0, 0, 0.18);

  display: flex;
  flex-wrap: wrap;
  /* flex-direction: column; */
  div {
    width: 100%;
  }
  button span {
    padding-top: 8px;
  }
`;

function Drawer(props) {
  const drawerRef = React.useRef(null);

  // Keep existing API: AppRoute passes onClick={() => uiState.hideMenu()}
  useOnClickOutside(drawerRef, event => {
    if (!props.show) return;
    if (typeof props.onClick === 'function') {
      props.onClick(event);
    }
  });

  return (
    <DrawerWrapperFull {...props}>
      <DrawerWrapper ref={drawerRef} {...props}>
        {props.children}
      </DrawerWrapper>
    </DrawerWrapperFull>
  );
}

export default Drawer;
